/*
   HTML converter for Subscript.
*/
export default {
  type: 'subscript',
  tagName: 'sub'
}
